export default <State, Key extends keyof State, Data extends State[Key]>(
    state: State,
    { objName, data }: { objName: Key; data: Data }
) => {
    state[objName] = data;
};
